import styled from 'styled-components';

export const DateTitleSC = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .day-title,
  .year-title,
  .month-title {
    border: none;
    background: none;
    outline: none;
    color: inherit;

    ${({ theme }) => theme.mappedTypography.h6.default};

    &.clickable:hover:not(:disabled) {
      text-decoration: underline;
      cursor: pointer;
    }

    :disabled {
      opacity: 0.5;
    }
  }
`;
